module.exports = {
      id: "rightarrow-usage",
      viewBox: "0 0 10 18",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#rightarrow",
      toString: function () {
        return this.url;
      }
    }